export default {
  webBaseURL: process.env.MIX_APP_URL,
  defaultImage: "https://cdn-icons-png.flaticon.com/512/1085/1085413.png",
  defaultUserImage: "https://cdn-icons-png.flaticon.com/512/1430/1430453.png"
}
